import * as React from "react";

export default function PreviewErrorMessage() {
    return (
        <div className="text-center z-[500] fixed bottom-xl right-xl p-xl bg-red-200 rounded-lg border-2 border-gray-800">
            <h3 className="font-bold">
                CAUTION: We had issues fetching data to render the preview of
                this page!
            </h3>
            <div className="p-l">
                We are using cached data, your recent changes may not be
                applied. <strong>Please try refreshing your browser.</strong>
                <br />
                If this error persists, reach out to <em>#help-dev</em> in slack
                and cc <em>@audience-oncl</em>.
            </div>
        </div>
    );
}
